// Copy for /adviser/resources, transcribed from the approved mockup
// (docs/omw419/copy/Adviser_Resources.txt).

export const RESOURCES_INTRO = {
  heading: 'Getting started with Old Mutual Will',
  lead: 'Here you will find all the resources you may need to understand the Wills proposition, engage your clients and get started on the platform.',
};

export const RESOURCES_BROCHURES = {
  heading: 'Brochures',
  subtitle: 'Brochures for you and your clients',
  cards: [
    {
      icon: 'document',
      title: 'OM Will Quick Start Guide',
      description:
        'A guide to support you with key facts to get started on the OM Will platform.',
      buttonText: 'Download',
      download: 'OMWill_Adviser_QuickStart_26_V5.pdf',
    },
    {
      icon: 'document',
      title: 'OM Will Customer Brochure',
      description:
        'An outline of the why you need a Will and the importance of planning for estate liquidity.',
      buttonText: 'Download',
      download: 'OMWill_CustomerBrochure_26_V4.pdf',
    },
  ],
};

export const RESOURCES_VIDEOS = {
  heading: 'Videos',
  subtitle: 'How-to videos showing you exactly how to navigate the platform',
  // videoKey names the whitelabel.videos entry that holds the embed URL.
  items: [
    {
      title: 'Guiding Customers Through the Process',
      description:
        'How to guide your customers through the process, from initial sign up to completion',
      videoKey: 'adviserGuidingCustomersVideo',
    },
    {
      title: 'How to Add a Customer',
      description:
        'A walk-through of the process of adding new customers to your adviser dashboard',
      videoKey: 'adviserAddCustomerVideo',
    },
    {
      title: 'The Will Validation Process',
      description:
        'How to assist your customer with the Will validation process',
      videoKey: 'adviserWillValidationVideo',
    },
  ],
};

export const RESOURCES_CHANNEL_CTA = {
  heading: 'For channel specific resources -',
  headingLight: 'Select your Channel',
  subtitle:
    'This will direct you to your channel-specific page with dedicated resources for your channel.',
};

export const RESOURCES_LINK_CARDS = [
  {
    icon: 'question-exchange',
    title: 'FAQs',
    description:
      'A full range of questions that advisers frequently ask, in one place, and easy to reference at any time.',
    buttonText: 'View FAQs',
    route: 'AdviserFaqs',
  },
  {
    icon: 'calculate',
    title: 'Calculators',
    description:
      'Use our free calculators to estimate capital gains tax and estate costs for your customers.',
    // Mockup reads "View FAQs" here; treated as a copy slip (spec Q7).
    buttonText: 'View Calculators',
    route: 'Calculators',
  },
];
